var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exclamation-triangle_svg__clip0_18783_13148)",
    fill: "#697177"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 37.5a2.806 2.806 0 002.813-2.813v-15c0-1.552-1.26-2.812-2.708-2.812-1.447 0-2.918 1.266-2.918 2.813v15A2.813 2.813 0 0030 37.5zm0 3.879a3.685 3.685 0 10.001 7.37 3.685 3.685 0 00-.001-7.37z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M59.332 48.867L34.336 6.211c-1.914-3.281-6.743-3.281-8.67 0L.682 48.867c-1.923 3.27.472 7.383 4.327 7.383H55c3.839 0 6.241-4.102 4.331-7.383zm-32.145-29.18A2.813 2.813 0 0130 16.875a2.817 2.817 0 012.813 2.813v15c0 1.552-1.26 2.812-2.708 2.812-1.447 0-2.918-1.254-2.918-2.813v-15zM30 48.75a3.685 3.685 0 11.001-7.37A3.685 3.685 0 0130 48.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exclamation-triangle_svg__clip0_18783_13148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  })))));
}
export default SvgExclamationTriangle;